export default "__VITE_ASSET__D42jaGs4__"